export default {
  list: { lazy: () => import('./moduleComponents'), component: 'ComponentModuleList' },
  edit: { lazy: () => import('./moduleComponents'), component: 'ComponentModuleEdit' },
  create: { lazy: () => import('./moduleComponents'), component: 'ComponentModuleCreate' },
}
